<template>
  <v-col cols="12" sm="6" lg="4">
    <v-sheet elevation="1" class="pa-4">
      <h3 class="headline mb-2">ไฟล์</h3>
      <v-row dense>
        <v-col v-for="asset in assets" :key="asset.label">
          <v-btn
            text
            v-on:click="handleCadaverAsset(asset.type)"
            :disabled="loadingCadaverAsset"
          >
            {{ asset.label }}
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>
    <v-snackbar v-model="loadingCadaverAsset">
      ⏳ กำลังโหลด
    </v-snackbar>
    <v-snackbar v-model="cadaverAssetNotFound">
      ❌ ไม่พบ
    </v-snackbar>
  </v-col>
</template>

<script>
import { apiFetch } from "../../api";

export default {
  name: "assetCard",
  data: () => ({
    assets: [
      {
        label: "รูปภาพ",
        type: "pictures"
      },
      {
        label: "คำไว้อาลัย",
        type: "condolences"
      }
    ],
    loadingCadaverAsset: false,
    cadaverAssetNotFound: false
  }),
  methods: {
    handleCadaverAsset(type) {
      this.cadaverAssetNotFound = false;
      this.loadingCadaverAsset = true;
      apiFetch(`/?asset=${type}`)
        .then(res => res.json())
        .then(json => {
          this.loadingCadaverAsset = false;
          if (json.cadaverAsset && json.cadaverAsset[type]) {
            window.open(json.cadaverAsset[type].download_url);
          } else {
            this.cadaverAssetNotFound = true;
          }
        });
    }
  }
};
</script>
